// extracted by mini-css-extract-plugin
export default {"commonCard":"CommonCard_commonCard__7cQhW"};